import Vue from 'vue'
import Vuex from 'vuex'
import state from './state.js'
import mutations from './mutations.js'
Vue.use(Vuex)
const store = new Vuex.Store({
    state,
    mutations,
	getters:{  
		getCityList: state=>state.cityList, 
		getCityInfo: state=>state.cityInfo 
	}
	
})
export default store


//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 